module.exports = __webpack_public_path__ + "static/img/YmgLOGO.3913477.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/YmgLOGO.png
// module id = P1lk
// module chunks = 1